module.exports = __webpack_public_path__ + "img/z_12_mathias-p-r-reding.13333510.jpg";